module.exports = __webpack_public_path__ + "img/burger_earth.44d9434d.svg";